import styled from 'styled-components';

export const Container = styled.div``;
export const TableWrapper = styled.div`
  margin-top: 1vh;
  width: 100%;
  height: 73vh;
`;
